import React, { Children, useEffect, useState } from 'react'
import { Autocomplete, TextField } from '@mui/material'
import { useStyles } from '../CaseDiagnosisStyles'
import { RootState } from 'reducers'
import { useDispatch, useSelector } from 'react-redux'
import { addListData, setSaveState } from '../../../actions'

export default function Comment({ location, childComment, commentType }): JSX.Element | null {
  const classes = useStyles()
  const dispatch = useDispatch()
  const selectedOptions = useSelector((state: RootState) => state.setReportDiagnosisData)
  const getDraftReportData = useSelector((state: RootState) => state.setDraftReportData)
  const [list, setList] = useState([] as any)
  const [selection, setSelection] = useState({ label: '' } as any)

  useEffect(() => {
    if (list[0]) {
      dispatch(addListData([...selectedOptions.payload, list[0]], true)) //to handle saved reordering
    }
  }, [list])

  useEffect(() => {
    if (selectedOptions.payload && selectedOptions.payload.length) {
      const data = selectedOptions.payload
      if (data.filter((commentItem) => commentItem.parent_id === childComment.id).length === 0) {
        setSelection({ label: '' })
      }
    } else {
      setSelection({ label: '' })
    }
  }, [selectedOptions])

  useEffect(() => {
    if (getDraftReportData && getDraftReportData.reportBuilder && getDraftReportData.reportBuilder[location]) {
      const data = getDraftReportData.reportBuilder[location]
      Object.keys(data).map((key) => {
        if (key === commentType) {
          if (data[key] && data[key].length) {
            data[key].map((commentItem) => {
              if (commentItem.parent_id === childComment.id) {
                setSelection(commentItem)
                return
              }
            })
          }
        }
      })
    }
  }, [getDraftReportData, location])

  const handleChange = async (event, newValue) => {
    if (!(selection.label && selection.label !== ' ')) {
      childComment.children.map(async (child) => {
        if (newValue.id === child.id) {
          child.category = commentType
          child.reportLabel = childComment.label
          if (child.displayValue) {
            child.displayValue = ''
          }
          setSelection(newValue)
          setList([child])
          if (newValue.subOptions) {
            await dispatch(setSaveState({ isSaveDisabled: true }))
          } else {
            await dispatch(setSaveState({ isSaveDisabled: false }))
          }
          return
        }
      })
    }
  }

  return (
    <>
      <Autocomplete
        value={selection.label}
        onChange={handleChange}
        disableClearable
        id="demo-simple-select"
        className={classes.TextBox}
        options={childComment.children ? childComment.children : []}
        placeholder="Select..."
        defaultValue={''}
        isOptionEqualToValue={(option, value) => option.label === value.label}
        renderInput={(params) => (
          <TextField style={{ left: '20px', width: '100%' }} {...params} label={childComment.label} />
        )}
      />
    </>
  )
}
